import styled from 'styled-components';


export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const Comment = styled.div`
    position: relative;

    textarea {
        width: 100%;
        height: 100px;
        padding: 0.5rem;
        border: 1px solid ${({ theme }) => theme.colors.gray400.main};
        border-radius: 5px;
        font-size: 1rem;
        font-weight: 400;
        resize: none;
        outline: none;
        color: ${({ theme }) => theme.colors.gray900.main};

        &:focus {
            border-color: ${({ theme }) => theme.colors.primaryBlue.main};
            color: ${({ theme }) => theme.colors.primaryBlue.main};
        }

        &::-webkit-scrollbar-track {
            background-color: transparent;
        }

        &::-webkit-scrollbar {
            width: 0.4rem;
            height: 0.4rem;
            background-color: transparent;
        }

        &::-webkit-scrollbar-thumb {
            border-radius: 50px;
            background-color: #bdbdbd;
        }
    }

    .counter {
        position: absolute;
        bottom: 2px;
        right: 2px;
        font-size: 0.75rem;
        color: ${({ theme }) => theme.colors.gray400.main};
    }
`;
